import React, {ReactElement, useState} from "react"
import Grid from "@mui/material/Grid";
import {IOrder} from "../../../../Order/interfaces/order.interface";
import {Order} from "../Order";
import {Button} from "../../../../App/components/Button";

interface Props {
  onClose: (order: IOrder) => void
}

export function Create(props: Props): ReactElement | null {
  const { onClose } = props
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Grid item>
      <Button
        size="large"
        type="button"
        onClick={handleOpen}
      >
        Создать
      </Button>
      {open ? (
        <Order
          open={open}
          onClose={(order?: IOrder) => {
            if (order) {
              onClose(order)
            }
            setOpen(false);
          }}
        />
      ): null}
    </Grid>
  )
}
